export const vibrate = (x: Array<number> = [200]): void => navigator.vibrate(x);